import e from"styled-components";import{TitleMedium as i}from"../TypographyStyle.js";var t;!function(e){e.STORY="story",e.POST="post",e.REEL="reel"}(t||(t={})),e.div`
	position: fixed;
	top: 0;
	left: 0;
	cursor: default;
	width: 100%;
	height: 100%;
	display: flex;
	background-color: rgba(0, 0, 0, 0.5);
	align-items: center;
	justify-content: center;
`,e.div`
	background-color: #fff;
	width: 1032px;
	height: auto;
	max-height: 600px;
	border-radius: 4px;
	padding: 24px;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
`,e.div`
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	gap: 20px;
	width: 1032px;
`,e(i)`
	padding: 6px 6px 20px 6px;
`,e.div`
	padding: 6px 6px 20px 6px;
`;const o=e.div`
	display: grid;
	grid-template-columns: repeat(
		${e=>e.mediaType==t.POST?6:8},
		${e=>e.mediaType==t.POST?156:113}px
	);
	grid-gap: 16px;
	overflow-y: scroll;
	height: calc(564px - 140px);
	overflow-y: auto;
	padding: 0 24px;

	/* Hide scrollbar by default */
	&::-webkit-scrollbar {
		width: 0.5em;
	}
	/* Show scrollbar on hover */
	&:hover::-webkit-scrollbar {
		width: 0.5em;
	}
`,p=e.div`
	position: relative;
	cursor: pointer;
	height: ${e=>e.mediaType==t.POST?155:180}px;
	padding: 2px;
	border-radius: 4px;
	border: 2px solid transparent;

	img {
		object-fit: cover;
		border-radius: 4px;
	}

	.overlay {
		position: absolute;
		top: 2px;
		left: 2px;
		width: ${e=>e.mediaType==t.POST?148:104}px;
		height: ${e=>e.mediaType==t.POST?148:172}px;
		background-color: rgba(255, 255, 255, 0.9);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		opacity: 0;
		transition: opacity 0.2s ease-in-out;
		border-radius: 4px;

		a {
			text-decoration: none;
		}
	}

	.overlay__caption {
		text-align: center;
		background: #fafafa;
		padding: 10px 20px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.overlay__redirection {
		display: flex;
		justify-content: center;
		gap: 5px;
		padding: 10px;
	}

	&:hover .overlay {
		opacity: 1;
	}

	&.selected {
		border: 2px solid #731dcf;
	}
`;e.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	padding-top: 12px;
	justify-content: space-between;
	border-top: 1px solid #e0e0e0;
`,e.div`
	flex: 1;
	padding-top: 10px;
	display: flex;
	justify-content: flex-start;
`,e.div`
	flex: 1;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 10px;
`;export{p as StyledProduct,o as StyledProductGrid};
